// Path: ./src/utils/pageUtil/toast.ts
import { ToastOptions, toast } from "react-toastify";

export const ToastConfiguration: ToastOptions = {
  position: "bottom-right",
  autoClose: 2000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  progress: undefined,
  theme: "light",
};

export const ExcelToastConfiguration: ToastOptions = {
  ...ToastConfiguration,
  autoClose: 20000,
  theme: "colored",
  hideProgressBar: false,
  pauseOnFocusLoss: true,
  closeButton: true,
  className: "excel-toast-notification",
  style: { minWidth: "300px", maxWidth: "500px" },
};

export const toastError = (message: string) => {
  toast.error(message, ToastConfiguration);
};

export const toastSuccess = (message: string) => {
  toast.success(message, ToastConfiguration);
};

export const toastWarn = (message: string) => {
  toast.warn(message);
};

export const toastExcelError = (message: string) => {
  toast.error(message, ExcelToastConfiguration);
};

export const toastExcelSuccess = (message: string) => {
  toast.success(message, ExcelToastConfiguration);
};
